import {Identify,identify} from '@amplitude/analytics-browser'
import logger from '@helpers/logger'

import { Properties } from './types'


const getIdentifyEvent = (properties: Properties) => {
  const identifyEvent = new Identify()

  for (const propertyKey in properties) {
    const property = properties[propertyKey]
    identifyEvent.set(propertyKey, property);

  }
  return identifyEvent
}

export default function setUserProperties (properties?: Properties) {
  if (!properties || !Object.keys(properties).length) return

  try {
    const identifyEvent = getIdentifyEvent(properties)
    identify(identifyEvent);
  } catch (error) {
    logger.error('Failed Amplitud setting User Properties', {properties, error})
  }
}
